const units = ['oz', 'lbs', 'g', 'kg', 'tbsp', 'tsp', 'cups', 'pints', 'count']

export const ingredientMeasurementOptions = units.map(unit => ({ name: unit, value: unit }))
